import { render, staticRenderFns } from "./CrCurrencyHelpList.vue?vue&type=template&id=55fc6f2e&"
import script from "./CrCurrencyHelpList.vue?vue&type=script&lang=js&"
export * from "./CrCurrencyHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports